import {SEND_MESSAGE} from '../Redux-store/actionType'
export const sendMessage = (message) =>{
    return (dispatch) =>{
        dispatch({ type: SEND_MESSAGE, payload:message });
    }
}